module.exports = __webpack_public_path__ + "assets/img/survey_2x.040ef118.png";